import React, { Component } from "react";
import ProductHeader from "../../ProductDetails/ProductHeader";
import MapPicker from "./MapPicker";
import { connect } from "react-redux";
import { getPosition, getSelectedCountry, getArea } from "./helpers";
import { Redirect } from "react-router-dom";

class MapPickerPage extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };
  render() {
    const {
      language,
      address,
      branch,
      branch_delivery_charges,
      areas,
      settings,
      branches,
      countries,
      cart,
    } = this.props;

    let selectedArea;
    if (settings.is_branch_based_ordering) {
      selectedArea = branch_delivery_charges.find(
        (bdc) => bdc.area_id === address?.area
      );
      // if (selectedArea) {
      //   selectedArea = {
      //     name: selectedArea.area,
      //     province_name: selectedArea.province_en,
      //   };
      // }
    } else {
      selectedArea = areas.find((a) => a.id === address?.area);
    }

    console.log(selectedArea);

    // Same checks from index.js

    if (!settings.enable_delivery && !settings.enable_pickup)
      return <Redirect to="/" />;
    if (cart.delivered_items <= 0 && cart.charged_items <= 0)
      return <Redirect to="/checkout/confirmation" />;
    if (this.props.history.action == "POP" && !this.props.customerContact)
      return <Redirect to="/checkout/details" />;

    if (!address) return <Redirect to="/" />;

    if (
      (address.selectedDeliveryType === 1 || branch.isPickup) &&
      address.pickupArea
    )
      return <Redirect to="/select/branch" />;

    // The reason why this is here and not in MapPicker.js is because this only renders once
    const selectedCountryID = getSelectedCountry(
      address,
      branch,
      branch_delivery_charges,
      areas,
      settings,
      branches
    );
    let countryObj = null;
    if (selectedCountryID) {
      countryObj = countries.find((c) => c.id === selectedCountryID);
    }

    return (
      <div
        className="border-top w-100"
        style={{
          marginTop: 55,
          backgroundColor: "#F5F5F5",
          height: "calc(100vh - 117px)",
          paddingRight: 1,
          overflow: "hidden",
          userSelect: "none",
        }}
      >
        <ProductHeader
          onBack={() => {
            if (this.props.history.location?.state?.checkout) {
              this.props.history.goBack();
            } else this.props.history.replace("/checkout/address", { type: 0 });
          }}
        />
        <MapPicker
          savePosition={(position) => {
            this.props.modifyAddress({ ...position, gpsConfirmed: true });
            this.props.history.replace(
              this.props.history.location?.state?.checkout
                ? "/checkout/confirmation"
                : "/checkout/address"
            );
          }}
          countryObj={countryObj}
          defaultPosition={
            getPosition(
              address,
              branch,
              branch_delivery_charges,
              areas,
              settings
            ) || {
              lat: settings.base_lat_lng?.split(",")[0],
              lng: settings.base_lat_lng?.split(",")[1],
            }
          }
          selectedAreaObj={selectedArea}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    address: state.customers.address,
    settings: state.store.store.settings,
    branch_delivery_charges: state.store.store.branch_delivery_charges,
    branch: state.branch,
    areas: state.store.store.areas,
    branches: state.store.store.branches,
    countries: state.store.store.all_countries || state.store.store.countries,
    cart: state.cart,
    customerContact: state.customers.customerContact,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    modifyAddress: (position) =>
      dispatch({ type: "MODIFY_ADDRESS", payload: position }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MapPickerPage);
